import React from 'react';
import moment from 'moment';
import CompletionDate from '../CompletionDate.jsx';

const StakeholderParticipationStatus = ({
  initiative,
  stakeholderParticipation,
}) => {
  const completedDate = stakeholderParticipation.completedAt
    ? moment(stakeholderParticipation.completedAt)
    : null;

  return (
    <div>
      <div className="strong">
        {stakeholderParticipation.completedAt ? 'Completed' : 'Pending'}
      </div>
      <div className="text-details">
        <CompletionDate
          completedAt={completedDate}
          endDate={initiative.endDate}
        />
      </div>
    </div>
  );
};

export default StakeholderParticipationStatus;
